<template>
    <div class="c-confirm-popup" >
        <div class="title">
            <h1 v-html="title"></h1>
        </div>
        <div class="btns">
            <button @click.prevent="onClickConfirm"  class="btn" :class="color">{{yes}}</button>
            <button @click.prevent="onClickCancel" v-if="showCancel" class="btn" :class="color">{{no}}</button>
        </div>
    </div>
</template>

<script>
export default {
    name : "ConfirmPopup",
    props: {
        title: {
            type: String,
            required: true,
            default: ""
        },
        yesLabel: {
            type: String,
            required: false,
            default: ""
        },
        noLabel: {
            type: String,
            required: false,
            default: ""
        },
        color : {
            type: String,
            required:false,
            default : "red"
        },
        showCancel: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        yes() {
            return this.yesLabel === "" ? this.$t("generic.yes") : this.yesLabel;
        },

        no() {
            return this.noLabel === "" ? this.$t("generic.no") : this.noLabel;
        }
    },

    methods: {
        onClickCancel() {
            this.$emit("cancel");
        },

        onClickConfirm() {
            this.$emit("confirm");
        }
    }
};
</script>

<style lang="scss" scoped>
.c-confirm-popup {
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(240,240,240, 1) 100%);
    height : 100%;
    width : 100%;
    position: fixed;
    left : 0;
    top : 0px;
    z-index: 55;

    .title {
        padding-top: 15vh;
        text-align:center;

        h1 {
            max-width: 75%;
        }
    }

    .btns {
        padding-top: 6vh;
        display: flex;
        justify-content: center;

        $size : 26vh;
        .btn {
            @extend .reset-btn;
            background-image : url('/img/confirm-btn-red.png');

            &.green {
                background-image : url('/img/confirm-btn-green.png');
            }
            &.yellow {
                background-image : url('/img/confirm-btn-yellow.png');
            }
            &.blue {
                background-image : url('/img/confirm-btn-blue.png');
            }

            background-size: 100%;
            background-repeat: no-repeat;
            font-size: 2.1em;
            margin: 0 2vw;
            width: $size;
            height: $size;
            color : white;
            font-weight: bold;
            text-transform: capitalize;

            &:nth-child(1) {
                @include widthBothIntro(650ms, 500ms, center)
            }
            &:nth-child(2) {
                @include widthBothIntro(650ms, 850ms, center)
            }
        }
    }
}
</style>